export default __webpack_public_path__ + "static/media/Inter-UI-Regular.8e212581.woff";